<template>
  <div class="choose-subscription-plan">
    <nuttrema-loader v-if="InstanceSubscriptionOptions.fetching" theme="full-overlay"></nuttrema-loader>
    <choose-subscription-plan
       v-else
      :email="email"
      :InstanceSubscriptionOptions="InstanceSubscriptionOptions"
      @saveSelection="onSaveSelection"
      @previousStep="onPreviousStep">
    </choose-subscription-plan>
  </div>
</template>

<script>
import { get } from 'lodash';
import { mapGetters, mapActions } from 'vuex';

import PageProps from 'components/mixins/page-props';

import ChooseSubscriptionPlan from 'components/ui/subscription/cmpt-choose-subscription-plan';

export default {
  name: 'page-create-instance-step-two',
  mixins: [
    PageProps,
  ],
  components: {
    ChooseSubscriptionPlan,
  },
  data() {
    return {
      email: null,
    };
  },
  computed: {
    ...mapGetters([
      'InstanceSubscriptionOptions',
    ]),
  },
  methods: {
    ...mapActions([
      'GetInstanceSubscriptionOptions',
      'SaveInstanceSubscriptionSelection',
    ]),
    onSaveSelection(payload) {
      this.SaveInstanceSubscriptionSelection({ payload })
        .then(() => {
          this.onSuccessEvent(null, { email: this.email });
        })
        .catch(() => {
          this.errorNotification();
        });
    },
    onPreviousStep() {
      this.$router.push({ name: get(this.meta, 'navigation.previous'), query: { email: this.email } });
    },
  },
  created() {
    this.email = get(this.$route, 'query.email', null);
    this.$store.dispatch('GetInstanceSubscriptionOptions', { query: { email: this.email } });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearInstanceSubscriptionOptions');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/public/create-instance/step-2/page-create-instance-step-two.vue